<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
        </template>
        <p
            class="text-sm mt-1 leading-5 text-gray-500"
            v-for="(paragraph, index) in paragraphs"
            :key="index"
            v-text="paragraph"
        ></p>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="form.busy" @click="form.submit()" v-text="button"></ui-button-new>
                <ui-button-new v-if="button2" primary class="w-full whitespace-nowrap ml-3" :loading="form2.busy" @click="form2.submit()" v-text="button2"></ui-button-new>
                <ui-button-new v-if="button3" primary class="w-full whitespace-nowrap ml-3" :loading="form3.busy" @click="form3.submit()" v-text="button3"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
export default {
    props: {
        handle: Function,
        handle2: Function,
        handle3: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: 'Confirmation'
        },
        paragraphs: {
            type: Array,
            default: () => [
                'Are you sure you want to proceed?',
            ],
        },
        button: {
            type: String,
            default: 'Yes, confirm'
        },
        button2: false,
        button3: false,
    },
    data () {
        return {
            form: new Form({}, async (form) => {
                await this.handle(form)
                this.close()
            }),
            form2: new Form({}, async (form2) => {
                await this.handle2(form2)
                this.close()
            }),
            form3: new Form({}, async (form3) => {
                await this.handle3(form3)
                this.close()
            }),

        }
    },
}
</script>
